// These values are from the ihis Networks table
export const NetCodes = Object.freeze({
	AshRehabProviderNetwork: 44,
	AshVptrProviderNetwork: 116,
	AshVptrPtPractitionerNetwork: 118,
	AshVptrOtPractitionerNetwork: 125,
	AshVptrStPractitionerNetwork: 126,
});
